import { StripeElementsOptions } from '@stripe/stripe-js';
import { useMemo } from 'react';
import { appTokens } from '../../theme/tokens';

type StripeTheme = Pick<StripeElementsOptions, 'appearance' | 'fonts'>;

export const useStripeTheme = (): StripeTheme =>
	useMemo(
		() => ( {
			appearance: {
				variables: {
					colorSuccess: appTokens.palette.primary,
					colorPrimary: appTokens.palette.primary,
					colorDanger: appTokens.palette.error,
					colorWarning: appTokens.palette.warning,
					colorText: appTokens.derived.black,
					colorTextSecondary: appTokens.palette.readableGray,
					fontFamily: 'Inter, sans-serif',
				},
			},
			fonts: [
				{
					cssSrc: appTokens.stripe.fontCssSrc,
				},
			],
		} ),
		[]
	);
